import type { Conf } from 'src/global';
import {
    addTags,
    disableChat,
    enableChat,
    getZe,
    handleFeaturesSupression,
    isSalesArticle,
    monitorUserEvent,
    setSalesText,
    setupHelpCenterTitle,
} from 'src/util';
import waitForDepartment from 'src/waitForDepartment';

import switchSolvvy from './switch-solvvy';

export const loadWebWidget = (conf: Conf) => {
    const zE = getZe();

    const switchChat = (isOnline: boolean) => {
        if (isOnline) {
            enableChat(conf);
            if (isSalesArticle(conf)) {
                zE.show();
                switchSolvvy('none');
            }

            const askQuestionBtn = document.querySelector('.solvvy-support-flow-relaunch-button');
            askQuestionBtn?.addEventListener('click', () => {
                zE.activate();
            });
        } else {
            disableChat();
            if (isSalesArticle(conf)) {
                zE.hide();
                switchSolvvy('block');
            }
        }
    };

    handleFeaturesSupression(['answerBot', 'talk']);
    monitorUserEvent(conf);
    zE('webWidget', 'helpCenter:setSuggestions', { labels: ['hc-start'] });
    addTags(['hc_pages'], conf);
    isSalesArticle(conf) && setSalesText();
    setupHelpCenterTitle();

    waitForDepartment(switchChat, conf.waitCount, conf);
};

export default loadWebWidget;
